import { Toast, Dialog } from 'vant';
import api from 'Plugins/api';
import { sessionclear, localget, localset, localremove } from 'Utils/storage.js';
import { CONSOLE_REQUEST_ENABLE, CONSOLE_RESPONSE_ENABLE } from '../index.js';
import { getSysType } from 'CommonUtils/plus.js';
import _this from '@/business/main';

// 获取 token
function getToken() {
  let access_token = localget('access_token');
  return access_token || '';
}

// 获取用户信息
function getUserInfo() {
  var userInfo = localget('userInfo') || {};
  if (userInfo.empInfo && userInfo.vipCorp) {
    return {...userInfo.empInfo, ...userInfo.vipCorp};
  }
  return {};
}

// 自定义请求拦截逻辑，处理权限，请求发送监控等 {mask:true}
export function requestSuccessFunc(requestObj) {
  // header 中要添加 用户工号 企业ID token 客户端来源
  var userInfo = getUserInfo();
  requestObj.headers.loginUserNo = encodeURI(userInfo.empNo) || '';
  requestObj.headers.corpId = userInfo.corpId || '';
  requestObj.headers.token = getToken();
  requestObj.headers['y-cli'] = getSysType();
  CONSOLE_REQUEST_ENABLE && console.info('requestInterceptorFunc', `url: ${requestObj.url}`, requestObj);
  // 控制遮罩层数量
  if (requestObj.loading === '0') {//无需加载遮罩
    1;
  } else {
    Counter.increment();//loading+1
    if (Counter.value() == 1) {
      Toast.loading({
        message: '加载中...',
        loadingType: 'spinner',
        forbidClick: true,
        duration: 0
      });
    }
  }

  return requestObj;
}

// 自定义发送请求失败逻辑，断网，请求发送监控等
export function requestFailFunc(requestError) {
  Counter.decrement(); // loading-1

  if (Counter.value() == 0) {
    Toast.clear();
  }

  Toast.fail({
    message: '请求超时，请检查网络或重新进入页面！',
  });

  return Promise.reject(requestError);
}

// 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
export function responseSuccessFunc(responseObj) {
  CONSOLE_RESPONSE_ENABLE && console.info('responseInterceptorFunc', `url: ${responseObj.config.url}`, responseObj);

  // 提报BUG接口不处理逻辑
  if (responseObj.config.url.indexOf('/mqc/bugManage/submitBug') > -1) {
    return false;
  }

  if (responseObj.config && responseObj.config.loading === '0') {
    0;
  } else {
    Counter.decrement();//loading-1
    //loading==0时 清除所有loading
    if (Counter.value() == 0) {
      Toast.clear();
    }
  }

  let resData = responseObj.data;
  let {errCode, status, tips} = resData;

  // 账号下线
  let faild = () => {
    let notNeedLogin = ['home', 'allMessage', 'approvalList', 'userCenter'];
    if (errCode == '100' || errCode == '3901' || errCode == '101') {
      if (notNeedLogin.indexOf(_this._route.name) !== -1 || responseObj.config.url.includes('/obt/personal/register/getMinOpenId')) {
        _this.$store.commit('SET_USERINFO', {});
        sessionclear();
        localremove('VUEX_STATE');
        localremove('userInfo');
        var AutoLogin = localget('AutoLogin') || {};
        AutoLogin.password = '';
        localset('AutoLogin', AutoLogin);
        localremove('access_token');
        return Promise.resolve(resData);
      } else {
        Dialog.alert({
          title: '提示',
          message: tips
        }).then(() => {
          // submitBug()
          sessionclear();
          localremove('VUEX_STATE');
          var AutoLogin = localget('AutoLogin') || {};
          AutoLogin.password = '';
          localset('AutoLogin', AutoLogin);
          localremove('access_token');
          window.location.href = '#/login';
        });
        return Promise.resolve(resData);
      }
    } else {
      localremove('VUEX_STATE');
      localremove('access_token');
      setTimeout(() => {
        window.location.href = '#/login';
      }, 10);
      return Promise.resolve(resData);
    }
  };

  //接口报错 提交报错信息
  let err = () => {
    Dialog({title: '提示', message: resData.tips}).then(() => {
      submitBug();
    });
    return Promise.reject(resData);
  };

  function submitBug() {
    var userInfo = getUserInfo();
    var params = {
      'level': 2, // BUG严重级别
      'fromSys': getSysType(), // 来源
      'userAgent': window.navigator.userAgent, // 浏览器或手机系统版本标识
      'corpName': userInfo.fullname + '/' + userInfo.deptName,
      'userName': userInfo.empName + '/' + userInfo.empNo, // 当前操作用户名称+登录工号，eg：张三/8888
      'requuid': resData.requuid, // 请求唯一标识，可以将此标识提供给技术人员，方便快速定位错误日志
      'reqPath': responseObj.config.url, // 接口地址
      'pagePath': window.location.href,
      'moduleName': '', // 模块名称
      'funName': '', // 功能名称
      'env': resData.env, // 环境
      'errCode': resData.errCode, // 业务错误代码
      'errMsg': resData.errMsg, // 业务处理失败时，异常信息
      'tips': resData.tips, // 业务处理失败时，错误提示信息
      'reqData': JSON.stringify(responseObj.config.data), // 请求参数对象
      'resData': JSON.stringify(resData), // 返回业务数据对象，没有则为空
      'remark': '' // 问题操作步骤描述，前端可自行组织或者由用户填报录入
    };

    // api['app/submitBug'](params)
  }

  let errCodes = {
    '1': () => Promise.resolve(resData),//如果业务成功，直接进成功回调
    '100': faild,//被挤掉
    '101': faild,//会话失效 token 失效
    '3901': faild,//被挤掉
    '102': err,
    '999': err,
    '998': err
  };
  if (errCodes[errCode]) {
    if (responseObj.config.url.indexOf('/obt/validateMinPrice') > -1) {
      return Promise.resolve(resData);
    }else if(responseObj.config.url.indexOf('obt/plane/shopping/queryFlightMinPrice')> -1){//查询航班未查到不显示弹窗直接
      return Promise.resolve(resData); 
    }
    else {
      return errCodes[errCode]();
    }
  } else if (status === 0) {
    return Promise.reject(resData);
  } else {
    if (resData.tips) {
      Toast.fail({
        message: resData.tips,
        duration: 4000
      });
    }
    return Promise.reject(resData);
  }
}

// 响应失败拦截，可根据 responseError.message 和 responseError.response.status 来做监控处理
export function responseFailFunc(responseError) {
  Counter.decrement();
  if (Counter.value() == 0) {
    Toast.clear();
  }

  Toast.fail({
    message: '请求超时，请检查网络或重新进入页面',
    duration: 3000
  });
  return Promise.reject(responseError);
}

//记录loading 数量
var Counter = (function () {
  var privateCounter = 0;

  function changeBy(val) {
    privateCounter += val;
  }

  return {
    increment: function () {
      changeBy(1);
    },
    decrement: function () {
      changeBy(-1);
    },
    value: function () {
      return privateCounter;
    }
  };
})();
